<script>
  import { link } from "../util/anchor-link";
  import Button from "./Button.svelte";

  export let bigger = false;
  export let href = "";
  export let external = false;
  export let text = "";
</script>

<a
  class="button-link"
  use:link
  target={external ? "_blank" : ""}
  {href}
  on:click
>
  <Button ignoreClick {bigger} {text}></Button>
</a>

<style>
  .button-link {
    text-decoration: none;
    font-weight: inherit;
  }
</style>
